import { baseApi } from './baseApi';

/**
 * Piece Images API endpoints
 * Handles CRUD operations for piece image management
 */
export const pieceImagesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET /pieces/:pieceId/images - Get images for piece
    getPieceImages: builder.query({
      query: (pieceId) => `/pieces/${pieceId}/images`,
      providesTags: (result, error, pieceId) => [
        { type: 'PieceImage', id: pieceId },
        ...(result || []).map(({ piece_image_id }) => ({ type: 'PieceImage', id: piece_image_id })),
      ],
    }),

    // POST /pieces/:pieceId/images - Upload piece image
    uploadPieceImage: builder.mutation({
      query: ({ pieceId, formData }) => ({
        url: `/pieces/${pieceId}/images`,
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: (result, error, { pieceId }) => [
        { type: 'PieceImage', id: pieceId },
        { type: 'Piece', id: pieceId },
      ],
    }),

    // PATCH /piece-images/:imageId - Update piece image
    updatePieceImage: builder.mutation({
      query: ({ imageId, data }) => ({
        url: `/piece-images/${imageId}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: (result, error, { imageId }) => [
        { type: 'PieceImage', id: imageId },
      ],
    }),

    // DELETE /piece-images/:imageId - Delete piece image
    deletePieceImage: builder.mutation({
      query: (imageId) => ({
        url: `/piece-images/${imageId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'PieceImage' }],
    }),

    // POST /pieces/:pieceId/images/reorder - Reorder piece images
    reorderPieceImages: builder.mutation({
      query: ({ pieceId, imageOrder }) => ({
        url: `/pieces/${pieceId}/images/reorder`,
        method: 'POST',
        body: { image_order: imageOrder },
      }),
      invalidatesTags: (result, error, { pieceId }) => [
        { type: 'PieceImage', id: pieceId },
      ],
    }),

    // POST /piece-images/:imageId/primary - Set primary piece image
    setPrimaryPieceImage: builder.mutation({
      query: (imageId) => ({
        url: `/piece-images/${imageId}/primary`,
        method: 'POST',
      }),
      invalidatesTags: [{ type: 'PieceImage' }],
    }),
  }),
});

// Export hooks for use in components
export const {
  useGetPieceImagesQuery,
  useUploadPieceImageMutation,
  useUpdatePieceImageMutation,
  useDeletePieceImageMutation,
  useReorderPieceImagesMutation,
  useSetPrimaryPieceImageMutation,
} = pieceImagesApi;

